import { createTheme, ThemeOptions } from '@material-ui/core/styles'

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    colors: {
      primary: string

      white: string
      blue: string
      blueLight: string
      blueDark: string
      green: string
      greenLight: string
      greenDark: string
      grey: string
      greyLight: string
      greyDark: string
      greenAlt: string
      validateFail: string
      validateOk: string
      red: string
      redLight: string
      redDark: string
      black: string
      blackLight: string
      blackDark: string
      coolBlue: string
      coolBlueLight: string
      coolBlueDark: string
    }
    primaryButtonColor: string
    buttonHoverBackground: string
    modal: {
      buttonBarColor: string
    }
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    colors?: {
      primary?: string

      white?: string
      blue?: string
      blueLight?: string
      blueDark?: string
      green?: string
      greenLight?: string
      greenDark?: string
      grey?: string
      greyLight?: string
      greyDark?: string
      greenAlt?: string
      validateFail?: string
      validateOk?: string
      red?: string
      redLight?: string
      redDark?: string
      black?: string
      blackLight?: string
      blackDark?: string
      coolBlue?: string
      coolBlueLight?: string
      coolBlueDark?: string
    }
    primaryButtonColor: string
    buttonHoverBackground: string
    modal: {
      buttonBarColor: string
    }
  }
}

export default function defaultCreateTheme(opts: ThemeOptions) {
  return createTheme(opts)
}
